<template>
  <div class="min-height">
    <TableLoading v-if="sampleOrderTakers.page === 0"/>
    <div v-else>
      <form @submit.prevent="createSampleOrder">
        <div class="row">
          <div class="col-sm-4">
            <div class="mb-3">
              <label>Taker of sample</label>
              <multiselect v-model="order.taker" :options="sampleOrderTakers.objects" :class="{
                        'is-invalid': submitted && v$.order.taker.$error,
                  }" class="multiselect-height-3" placeholder="Select one" label="name" track-by="name" :searchable="true" @search-change="asyncFindSampler">
              </multiselect>
              <p
                  v-for="error of v$.order.taker.$errors"
                  :key="error.$uid"
                  class="invalid-feedback"
              >
                {{error.$message}}
              </p>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="mb-3">
              <label>Customer (Branch)</label>
              <multiselect v-model="order.customer" :options="branches.objects"
                           class="multiselect-height-3" placeholder="Select one" label="name" track-by="name" :searchable="true" :internal-search="false" @search-change="asyncFindBranch">
                <span slot="noResult">No branch found. Change search query.</span>
              </multiselect>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="mb-3">
              <label>Delivery Date</label>
              <DatePicker v-model="order.delivery_date" :disabled-dates="disabledDates" format="yyyy-MM-dd"></DatePicker>
              <p
                  v-for="error of v$.order.delivery_date.$errors"
                  :key="error.$uid"
                  class="invalid-feedback"
              >
                {{error.$message}}
              </p>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="mb-3">
              <label>Ordered By</label>
              <input
                  v-model="order.ordered_by"
                  name="name"
                  type="text"
                  class="form-control py-3"
                  :class="{
                        'is-invalid': submitted && v$.order.ordered_by.$error,
                      }"
              />
              <p
                  v-for="error of v$.order.ordered_by.$errors"
                  :key="error.$uid"
                  class="invalid-feedback"
              >
                {{error.$message}}
              </p>
            </div>
          </div>
          <div class="row"  v-for="(p, r) in order.items"
               :key="r">
            <div class="mb-3 col-sm-4">
              <label>Product</label>
              <multiselect v-model="order.items[r].product" :options="products.objects" class="multiselect-height-3"
                           placeholder="Select one" label="productName" track-by="productName" :searchable="true" :internal-search="false"
                           @search-change="asyncFindProduct" @input="productSelected" @select="setIndex(r)">
                <span slot="noResult">No product found. Change search query.</span>
              </multiselect>
            </div>
            <div class="mb-3 col-sm-3">
              <label>Shipment</label>
              <multiselect v-model="order.items[r].shipment" :options="order.items[r].shipments" class="multiselect-height-3"
                           placeholder="Select one" :custom-label="customLabel" track-by="orderId" :searchable="true">
                <span slot="noResult">No shipment found. Change search query.</span>
              </multiselect>
            </div>
            <div class="mb-3 col-sm-2">
              <label>Quantity</label>
              <input
                  v-model="order.items[r].quantity"
                  type="number"
                  class="form-control py-3"
              />
            </div>
            <div class="mb-3 col-sm-3 form-group align-self-end">
              <button
                  class="btn rounded-circle btn-dark mx-2"
                  v-if="r > 0"
                  @click.prevent="removeProducts(order.items, r)"
              >
                <i class="bx bx-minus"></i>
              </button>
              <button
                  class="btn rounded-circle btn-primary mx-2"
                  v-if="r == order.items.length - 1"
                  @click.prevent="addProducts(order.items)"
              >
                <i class="bx bx-plus"></i>
              </button>
            </div>
          </div>
        </div>
        <div v-for="(error, index) in ordersErrors" :key="index" style="color: #D13704;">
          {{error.message}}
        </div>
        <div class="mt-3 align-middle">
          <b-button variant="primary" size="lg" class="py-3 h3 w-100" disabled v-if="ordersLoading">
            <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
            Loading
          </b-button>
          <b-button variant="primary" size="lg" class="py-3 h3 text-white w-100" type="submit" v-else>
            Create Sample Order
          </b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import Multiselect from 'vue-multiselect'
import {ALL_SAMPLE_ORDER_TAKERS} from "@/gql/orders";
import moment from "moment";
import {ALL_CUSTOMER_BRANCHES, ALL_PRODUCTS_SIMPLE, ALL_SHIPMENTS} from "@/gql";
import {mapGetters} from "vuex";
import TableLoading from "@/components/TableLoading";
import DatePicker from "@sum.cumo/vue-datepicker";
export default {
name: "sample-order-form-component",
  setup () {
    return { v$: useVuelidate() }
  },
  components: {
    TableLoading,
    Multiselect,
    DatePicker
  },
  data(){
    return{
      disabledDates: {
        to: new Date(moment().format('YYYY-MM-DD'))
      },
      order:{
        ordered_by: "",
        delivery_date: "",
        taker: "",
        customer: "",
        items: [{ product: "", shipment: "" , quantity: "", shipments: [] }]
      },
      sampleOrderTakers: {
        page: 0,
        objects: []
      },
      samplerSearchKeyword: "",
      productSearchKeyword: "",
      shipmentSearchKeyword: "",
      branchSearchKeyword: "",
      shipments: {
        objects: []
      },
      branches: {
        objects: []
      },
      products: {
        objects: []
      },
      item_index: 0,
      submitted: false
    }
  },
  validations () {
    return {
      order:{
        ordered_by: {required},
        delivery_date: {required},
        taker: {required},
      }
    }
  },
  apollo: {
    sampleOrderTakers: {
      query: ALL_SAMPLE_ORDER_TAKERS,
      variables(){
        return {
          page: 1,
          perPage: 30,
          searchKeyword: this.samplerSearchKeyword
        }
      }
    },
    shipments: {
      query: ALL_SHIPMENTS,
      variables(){
        return {
          page: 1,
          perPage:30,
          searchKeyword: this.shipmentSearchKeyword
        }
      }
    },
    products: {
      query: ALL_PRODUCTS_SIMPLE,
      variables(){
        return {
          page: 1,
          perPage: 30,
          searchKeyword: this.productSearchKeyword,
          shipmentSearchKeyword: this.shipmentSearchKeyword,
          excludeUnavailableForOrder: true,
        }
      }
    },
    branches: {
      query: ALL_CUSTOMER_BRANCHES,
      variables(){
        return {
          page: 1,
          perPage: 30,
          branchSearchKeyword: this.branchSearchKeyword
        }
      }
    },
  },
  computed: {
    ... mapGetters({
      ordersLoading: 'orders/ordersLoading',
      ordersErrors: 'orders/ordersErrors'
    }),
  },
  methods: {
    async createSampleOrder() {
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }

      const new_items = []
      this.order.items.forEach((item) => {
        new_items.push({'itemId': item.product.publicId, 'itemCount': parseInt(item.quantity), 'shipmentId': item.shipment.publicId})
      })
      const data = {
        orderedBy: this.order.ordered_by,
        sampleOrderTaker: this.order.taker.publicId,
        deliveryDate: moment(this.order.delivery_date).format('YYYY-MM-DD'),
        items: new_items
      }
      this.$emit('orderAction', data)
      this.v$.$touch();
    },
    customLabel ({ orderId, warehouseId, expiryDate }) {
      const date = moment(expiryDate).format('ll')
      if (!warehouseId){
        return `${orderId} – No Warehouse - Expiry: ${date}`
      }else {
        return `${orderId} – ${warehouseId?.name} - Expiry: ${date}`
      }
    },
    removeProducts(p, i) {
      p.splice(i, 1);
    },
    addProducts(p) {
      p.push({ product: "", shipment: "" , quantity: "", shipments: [] });
    },
    asyncFindSampler (query) {
      this.samplerSearchKeyword = query
    },
    asyncFindProduct (query) {
      this.productSearchKeyword = query
    },
    asyncFindShipment (query) {
      this.shipmentSearchKeyword = query
    },
    setIndex(pos){
      this.item_index = pos
    },
    productSelected(value){
      this.order.items[this.item_index].shipments = value.shipments
    },
    asyncFindBranch (query) {
      this.branchSearchKeyword = query
    },
  },
}
</script>

<style scoped>

</style>
